'use client'

import React from 'react'
import { Container } from 'react-bootstrap'

import Banner from './component/Banner'
import WhoWeAre from './component/WhoWeAre'
import MissionValues from './component/MissionValues'
import OurJourney from './component/OurJourney'
import MeetMetalbookTeam from './component/MeetMetalbookTeam'
import ReadyToOrder from '../../components/ReadyToOrder'
import MetalbookWinner from './component/MetalbookWinner'
import OurInvestors from './component/OurInvestors'
import ExplorePassion from './component/ExplorePassion'
import SpeakToUs from './component/SpeakToUs'
import OurTeam from './component/OurTeam'

const AboutUs = () => {
	return (
		<>
			<Container fluid='lg'>
				<Banner />
			</Container>
			<WhoWeAre />
			<MissionValues />
			<OurJourney />
			<MeetMetalbookTeam />
			<ReadyToOrder />
			<Container fluid='lg'>
				<OurInvestors />
			</Container>
			<MetalbookWinner />
			<Container fluid='lg'>
				<OurTeam />
			</Container>
			<ExplorePassion />
			<SpeakToUs />
		</>
	)
}

export default AboutUs
